import { FormObjType } from "DataTypes/Form";
import DateTime from "Utils/DateTime";

export const AddEditForm: FormObjType[] = [
  {
    id: "substanceName",
    label: "Substance Name",
    placeholder: "Enter substance name",
    boxType: "input",
    boxSize: 4,
    validatetype: "any",
    required: true,
    enableFormLoad: true,
  },
  {
    id: "startDate",
    label: "Start Date",
    placeholder: "Select start date",
    boxType: "date",
    boxSize: 4,
    validatetype: "date",
    enableFormLoad: true,
    maxVal: DateTime.CurrentDate()
  },
  {
    id: "endDate",
    label: "End Date",
    placeholder: "Select end date",
    boxType: "date",
    boxSize: 4,
    validatetype: "date",
    enableFormLoad: true,
    maxVal: DateTime.CurrentDate()
  }
]